import { Notification } from 'element-ui';
import Cookies from 'js-cookie'

export default {
  namespaced: true,

  state: {
    menuCollapsed: true,
    isMobile: false,
    language: Cookies.get('language') || 'es',
  },

  getters: {
    menuCollapsed: (state) => state.menuCollapsed,
    isMobile: (state) => !!state.isMobile,
    paginationLayout: (state) =>
      state.isMobile
        ? 'total, prev, pager, next'
        : 'total, sizes, prev, pager, next',
    labelPosition: (state) =>
      state.isMobile ? 'top' : undefined,
    labelWidth: (state) =>
      state.isMobile ? undefined : '180px',
    language: (state) => state.language
  },

  mutations: {
    COLLAPSE_MENU(state) {
      state.menuCollapsed = true;
    },

    TOGGLE_MENU(state) {
      state.menuCollapsed = !state.menuCollapsed;
    },

    RESIZE(state, payload) {
      state.isMobile = payload.width < 576;
    },

    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
  },

  actions: {
    resize({ commit }, payload) {
      commit('RESIZE', payload);
    },

    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },

    collapseMenu({ commit }) {
      commit('COLLAPSE_MENU');
    },

    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },

    success(context, payload) {
      Notification({
        showClose: true,
        message: payload,
        type: 'success',
        duration: 6000
      });
    },

    error(context, payload) {
      let message;

      if (
        payload.response &&
        payload.response.status === 400
      ) {
        message = payload.response.data;
      } else {
        message = payload.message;
      }

      if (!message) {
        message = 'Ops, an error occurred';
      }
      // eslint-disable-next-line

      Notification({
        showClose: true,
        message,

        type: 'error',
        duration: 6000
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/shared-store.js